// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { SearchFormProps } from './SearchForm.types';

export const SearchFormDynamic = dynamic<SearchFormProps>(() =>
  import('./SearchForm').then(module => module.SearchForm)
);
export { SearchFormEditable, SearchForm as SearchFormNonEditable } from './SearchForm';
